import { Trans, useLingui } from "@lingui/react/macro";
import { Chip } from "@silversea-ssc/ui-components-react";
import { FareCode } from "@silversea-ssc/web-fares";
import React from "react";
import { arrayIsNotEmpty } from "src/utils/checks";
import { fareCodeLabel } from "src/utils/fares";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { formatConjunction } from "src/utils/localization/formatConjunction";
import clsx from "clsx";
import * as styles from "./IncludedWithFaresBadge.module.scss";

type Props = {
  fareCodes: FareCode[];
  className?: string;
};

const IncludedWithFaresBadge: React.FC<Props> = ({ fareCodes, className }) => {
  const { t } = useLingui();
  const language = useLanguage();
  if (!arrayIsNotEmpty(fareCodes)) return null;

  const names = fareCodes.map((f) => t(fareCodeLabel(f)));
  const fares = formatConjunction(names, language.code);

  return (
    <Chip background="transparent" className={clsx(styles.outline, className)}>
      <Trans>Included with {fares}</Trans>
    </Chip>
  );
};

export default IncludedWithFaresBadge;
